import React from "react";
import { useGetAboutMe } from "pages/Profile/hooks/useGetAboutMe";
import { sanitizeHighlightsForDisplay } from "shared/utils/dom/sanitizeHighlightsHtml";

const AboutMePrint = () => {
  const { aboutMe } = useGetAboutMe();

  if (!aboutMe?.currentAppearance) return null;

  return (
    <p
      className="mb-2.5"
      dangerouslySetInnerHTML={{
        __html: sanitizeHighlightsForDisplay(aboutMe.currentAppearance),
      }}
    />
  );
};

export default AboutMePrint;
